/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderCreateResult
 */
export interface OrderCreateResult {
    /**
     * 
     * @type {string}
     * @memberof OrderCreateResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCreateResult
     */
    code: string;
}

/**
 * Check if a given object implements the OrderCreateResult interface.
 */
// @ts-ignore
export function instanceOfOrderCreateResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

// @ts-ignore
export function OrderCreateResultFromJSON(json: any): OrderCreateResult {
    return OrderCreateResultFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderCreateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCreateResult {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
    };
}

// @ts-ignore
export function OrderCreateResultToJSON(value?: OrderCreateResult | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
    };
}

